import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { Router } from 'react-router-dom';
import { AuthContextProvider } from './logic';
import { history } from './common';

ReactDOM.render(
	<Router history={history}>
		<AuthContextProvider>
			<App />
		</AuthContextProvider>
	</Router>,
	document.getElementById('root')
);
